<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12 col-md-6">
                    <h1 class="text-white pt-3 px-3">หน้าจัดการราคาขนส่ง</h1>
                    <p
                        class="text-white pb-3 px-3"
                    >เพิ่ม แก้ไข ลบราคาขนส่ง และแสดงตารางรายละเอียดราคาขนส่งทั้งหมดที่มีอยู่</p>
                </div>
            </div>
        </base-header>
        <BlockUI v-if="loader.busy">
            <div class="loader"></div>
        </BlockUI>
        <div class="container-fluid mt--7 mb-5">
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-xl-12 m-auto">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">เลือกขนส่ง</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <DetailsCourier
                                ref="detailsCourier"
                                :rateManagement="true"
                                :inputCourier="inputCourier"
                                :validateData="validateData"
                                :permission="{isGen: false}"
                                :isEdit="false"
                            />
                            <hr class="my-4" />
                        </template>
                        <h4 class="mb-4">จัดการขนส่งร้านค้า</h4>
                        <SelectTypeFilter :search="search"/>
                        <SearchRateManagement 
                            ref="searchRateManagement" 
                            :search="search"
                            @searchShop="searchShop"
                        />

                        <h3 class="mb-4">จำนวนร้านค้าที่เลือกทั้งหมด {{ (this.$refs.tableReteManagement) ? this.$refs.tableReteManagement.selectedShop.length : 0 }} รายการ</h3>

                        <TableReteManagement ref="tableReteManagement" :itemRateManagement="itemRateManagement" />

                        <div class="row py-4 justify-content-end">
                            <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                <button type="button" class="btn btn-secondary btn-block btn-icon py-3" @click="reloadPage()">ยกเลิก</button>
                            </div>
                            <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                <button 
                                    type="button" 
                                    class="btn btn-success btn-block btn-icon py-3" 
                                    :disabled="(this.$refs.tableReteManagement) ? this.$refs.tableReteManagement.selectedShop.length < 1 : false"
                                    @click="createCourierForShopRateManagement()"
                                >
                                    เพิ่มขนส่งที่เลือก
                                </button>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import DetailsCourier  from '@/components/custom/transport/DetailsCourier'
import SelectTypeFilter  from '@/components/custom/ratemanagement/SelectTypeFilter'
import SearchRateManagement  from '@/components/custom/ratemanagement/SearchRateManagement'
import TableReteManagement  from '@/components/custom/ratemanagement/TableReteManagement'
import { getCourierById , searchShopForRateManagement , createCourierRateManagement } from "@/axios/courier.js";
import { showConfirmSuccessModal , showErrorModal } from "@/components/modalNotification.js";

export default {
    name:"ratemanagement",
    components:{
        DetailsCourier,
        SelectTypeFilter,
        SearchRateManagement,
        TableReteManagement
    },
    data(){
        return{
            loader: {
                busy: true
            },
            search:{
                typeFilter: 'FILTER',
                courierKey: '',
                rateCode: '',
                underShop: null,
                packageShop: null,
                shopCode: '',
                shopCodeArray: [],
                forceCreate: false
            },
            itemRateManagement: [],
            inputCourier: {
                btnTitle: "",
                descriptionCouier: "",
                courierName: "",
                courierKey: "",
                selectCourier: "",
                selectCourierType: this.$USER_LOGIN.get().isSuperadmin?0:1,
                adminSelectCourierType: 1,
                refCode:"",
                rateCode:"", 
            },
            validateData: {
                submitted: false,
                checkInput: {
                    courierKey: null
                }
            }
        }
    },
    mounted() {
        getCourierById( this.$route.params.Id ).then( dataCourier => {
            this.loader.busy = false;
            this.inputCourier = {
                btnTitle: dataCourier.title,
                descriptionCouier: dataCourier.description,
                courierName: dataCourier.name,
                courierKey: dataCourier.key,
                refCode: dataCourier.ref_code,
                selectCourier: dataCourier.title,
                rateCode: dataCourier.default_courier_code,
                selectCourierType: dataCourier.is_shippop ? dataCourier.prebarcode ? 2 : 1 : 0,
                effective_date: (this.$USER_LOGIN.get().isShippop && dataCourier.effective_date) ? this.setFormatDateTimeLocal(dataCourier.effective_date) : dataCourier.effective_date,
                expired_date: (this.$USER_LOGIN.get().isShippop && dataCourier.expired_date) ? this.setFormatDateTimeLocal(dataCourier.expired_date) : dataCourier.expired_date
            }
        }).catch(e => {
            showErrorModal( e )
            this.loader.busy = false;
        });
    },
    methods: {
        searchShop(){
            this.$refs.searchRateManagement.isLoadSearch = true
            searchShopForRateManagement( this.search ).then( shop => {
                this.$refs.searchRateManagement.isLoadSearch = false
                this.itemRateManagement = shop
            }).catch(e => {
                showErrorModal( e )
                this.$refs.searchRateManagement.isLoadSearch = false
            });
        },
        createCourierForShopRateManagement(){
            this.loader.busy = true;
            createCourierRateManagement( this.$refs.tableReteManagement.selectedShop , this.inputCourier.rateCode , this.search.forceCreate ).then( res => {
                this.loader.busy = false;
                if(res.status){
                    showConfirmSuccessModal('เพิ่มขนส่งให้ร้านค้าสำเร็จ')
                }
            }).catch(e => {
                showErrorModal( e )
                this.loader.busy = false;
            });
        },
        reloadPage() {
            location.reload()
        },
        setFormatDateTimeLocal( dateTime ){
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm")
        },
        setFormatDateTimeSaveDatabase( dateTime ){
            return moment(dateTime, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD HH:mm:ss")
        }
    }
}
</script>